var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main", { staticClass: "page-index" }, [
    _c(
      "section",
      { staticClass: "page-index__section" },
      [
        _c(
          "v-content-section",
          {
            staticClass: "page-index__content",
            attrs: { animation: true, content: _vm.content, variant: "black" }
          },
          [
            _c(
              "div",
              { staticClass: "slider__mockup-overflow page-index__overflow" },
              [
                _c(
                  "div",
                  { ref: "phone", staticClass: "slider__mockup-wrapper" },
                  [
                    _c("div", { staticClass: "slider__mockup-svg icon" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            viewBox: "0 0 251 500",
                            width: "251px",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [_c("use", { attrs: { "xlink:href": "#ui/mock" } })]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "slider__mockup-items" }, [
                      _c(
                        "div",
                        { staticClass: "slider__mockup-item" },
                        [
                          _c("v-image", {
                            attrs: {
                              alt: _vm.$t("homepage.visual.image.alt"),
                              "aspect-ratio": 218 / 472,
                              tiny: _vm.visual
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-index__cards" },
                  [
                    _c("v-icon", {
                      ref: "green",
                      staticClass: "page-index__card",
                      attrs: { name: "symbols/cards/visa" }
                    })
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c("v-benefits", { ref: "benefits" }),
        _vm._v(" "),
        _c("v-carousel", { attrs: { data: _vm.carouselTop } }),
        _vm._v(" "),
        _c("v-carousel", { attrs: { data: _vm.carouselBottom } })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }